<span
  [ngbPopover]="details == 'Multiple' ? customPopover : null"
  triggers="mouseenter:mouseleave"
  placement="right"
  container="body">
  {{ details }}
</span>

<ng-template #customPopover>
 <!-- <div class="popover-header">
    Organizations
  </div> -->
  <ul class="popover-list mb-0">
    <li *ngFor="let role of roles">{{ role }}</li>
  </ul> 
</ng-template>